export default __webpack_public_path__ + "static/media/HibaResume.75ba2b84.pdf";